import React, { useEffect,useState } from 'react';
import Button from '../button';
import LoadingOverlay from '../loadingOverlay';
import {get, post } from '../../request'
import './styles.scss';

function ChoosePayTypeDialog({ initItem, onConfirm, onCancel,  isShow}) {
    const [isLoading, setIsLoading] = useState(false);
    const [payType, setPayType] = useState(0);
    const [item, setInputs] = useState(initItem || {});
    useEffect(() => {
        setInputs(initItem);


    }, [ initItem]);

    const showDialog = () => {
        //setIsVisible(true);
    };

    const hideDialog = () => {
        //setIsVisible(false);
        if (onCancel) {
            onCancel(false);
        }
    };
    const handleClick = () => {
        //onConfirm();
        
       
    };

    const handleCancel = () => {
        //onCancel();
        if (onCancel) {
            onCancel();
        }
        hideDialog();
    };
    const chooseType = (type) => {
        setPayType(type);
        if (!item.imageSrc && item.id && type==1) {
            setIsLoading(true);
            get('delianapi/businessCreditPay/GetCreditErweiCodeByOrder', { orderid: item.id }).then((response) => {
                setIsLoading(false);
                if (response.statusCode !== 200) {
                    setInputs({ ...item, errorMessage: response.message });
                    return;
                }
                setInputs({ ...item, imageSrc: response.items[0] });
            });
        }
    }
    return (
        <div className="dialog choosePayType" style={{ display: isShow ? 'flex' : 'none' }}>
            <div className="dialogModel">
                <div className="closeDialog" onClick={() => handleCancel()}></div>
                    
                    <div className="dialogTitle">选择付款方式</div>
                <div className="dialog-content">
                    <div className="payTypeList">
                        <div className={`payType ${payType == 0 ? 'selected' : ''}`} onClick={()=> chooseType(0)}>
                            传统支付方式
                        </div>
                        <div className={`payType payType1 ${payType == 1 ? 'selected' : ''}`} onClick={()=>chooseType(1)}>
                            网商采购贷
                        </div>
                    </div>
                    {
                        payType == 0 &&
                        <div className="width100">
                            <div className="dialog-in">传统支付方式：银行转账</div>
                            <div className="red fs-12">完成银行转账后，订单状态不会立即更新，请耐心等待3-5个工作日。</div>
                            
                            <div className="content-div">
                                <div className="">
                                    转账银行：中国银行嘉定支行
                                </div>
                                <div className="">
                                    银行账号：445568828744
                                </div>
                                <div className="">
                                    单位名称：上海德联车护网络发展有限公司
                                </div>
                            </div>
                        </div>
                    }
                    {
                        payType == 1 &&
                        <div className="width100">
                            <div className="dialog-in">网商采购贷</div>
                            <div className="red fs-12">二维码30分钟有效期，请尽快支付</div>
                            <div className="content-div">
                                {
                                    item.imageSrc && <img src={item.imageSrc} />
                                }
                                {
                                    item.errorMessage &&
                                    <div className="info-div red " >
                                        {item.errorMessage }
                                    </div>
                                }
                                {
                                    !item.errorMessage &&
                                    <div className="info-div">
                                        请使用<span className="red">支付宝扫码</span>，进行网商采购贷支付
                                    </div>
                                }                                
                            </div>
                        </div>
                    }
                    <div className="btn-div">
                                              
                        <Button btnclass={`login_btn `} onClick={() => handleClick()}
                            title={payType == 0 ? '已转账，关闭' : '已支付，查询支付状态'}  />
                    </div>
                                          
                    </div>
            </div>
            <LoadingOverlay isLoading={isLoading} />
        </div>
    );
};

export default ChoosePayTypeDialog;